var map = {
	"./admin.js": "iF70",
	"./auth.js": "9MnV",
	"./check-auth.js": "NzBb",
	"./guest.js": "bf1s",
	"./locale.js": "qdOK"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sNq1";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/middleware nonrecursive .*\.js$
// module id = sNq1
// module chunks = 60